import React, { useState } from 'react';
import { AdminLayout } from './components/AdminLayout';
import { AdminRoute } from './components/AdminRoute';
import { AdminProvider } from './context/AdminContext';
import {
  AdminStats,
  AllListings,
  AdminUsers,
  CreditPackages,
  DealerPackages,
  PromotionPackages,
  PaymentsManagement,
  CreditTransactions,
  CreditAnalytics,
  VehicleRequestQueue,
  VehicleManagement,
  VehicleFeatures,
  PushNotifications,
  ReportsQueue,
  AdminBulkUpload,
  AdminSingleListing,
  InfluencerLinks,
  MarketingAnalytics,
  GiveawayManagement,
} from './components';
import AdminDealers from './components/AdminDealers';
import './admin.css';

const AdminDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const handleViewListing = (listing: any) => {
    const id = listing?.slug || listing?.id;
    if (id) window.open(`/listing/${id}`, '_blank');
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <AdminStats />;
      case 'users':
        return <AdminUsers />;
      case 'dealers':
        return <AdminDealers />;
      case 'all-listings':
        return <AllListings onViewListing={handleViewListing} />;
      case 'credit-packages':
        return <CreditPackages />;
      case 'dealer-packages':
        return <DealerPackages />;
      case 'promotion-packages':
        return <PromotionPackages />;
      case 'payments':
        return <PaymentsManagement />;
      case 'credit-transactions':
        return <CreditTransactions />;
      case 'credit-analytics':
        return <CreditAnalytics />;
      case 'vehicle-requests':
        return <VehicleRequestQueue />;
      case 'vehicle-management':
        return <VehicleManagement />;
      case 'vehicle-features':
        return <VehicleFeatures />;
      case 'push-notifications':
        return <PushNotifications />;
      case 'reports':
        return <ReportsQueue />;
      case 'influencer-links':
        return <InfluencerLinks />;
      case 'marketing-analytics':
        return <MarketingAnalytics />;
      case 'giveaway':
        return <GiveawayManagement />;
      case 'bulk-upload':
        return <AdminBulkUpload />;
      case 'single-listing':
        return <AdminSingleListing />;
      default:
        return <AdminStats />;
    }
  };

  return (
    <AdminProvider>
      <AdminRoute>
        <AdminLayout activeTab={activeTab} onTabChange={setActiveTab}>
          {renderContent()}
        </AdminLayout>
      </AdminRoute>
    </AdminProvider>
  );
};

export default AdminDashboard;
